export default "__VITE_ASSET__D9HZ$u$0__"